import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { UntypedFormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

import { Fields, Options } from 'src/app/shared/models/candidateprofile-genmodel';
import { GenModelService } from 'src/app/core/services/gen-model.service';

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: [],
  standalone: false,
})
export class AutocompleteComponent implements OnInit {
  field: Fields;
  group: UntypedFormGroup;
  filteredOptions: Options[];
  digitalTags: Options[];
  designationData;
  desinationId;
  @Output() roleDetails: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private http: HttpClient,
    private apiData: GenModelService,
  ) {}

  ngOnInit() {
    // console.log('Options LiSt', this.field.options);
    // console.log('this.field.name', this.field.name)
    // console.log('this.group', this.group);
    this.apiData.digitalTags.subscribe((res) => {
      this.digitalTags = res;
    });
    if (this.field.name === 'digitalTag') {
      this.filteredOptions = this.digitalTags;
    }
    this.group.get(this.field.name).valueChanges.subscribe((value) => {
      // console.log(value);
      if (value && value.length >= 1) {
        this._filter(value, this.field.url);
        if (this.field.name === 'digitalOffering') {
          this.group.get('digitalTag').setValue('');
        }
      } else {
        this.filteredOptions = [];
      }
    });
    // if (this.field.name == 'designation') {
    //   // console.log("designation----")
    //   if (this.field.value && this.field.value != undefined && this.field.value != null) {
    //     // console.log("this.field.value --- ", this.field.value)
    //     this.http.get<any>(this.field.url + '/' + this.field.value).subscribe(data => {

    //       // console.log("data---" + JSON.stringify(data))
    //       this.desinationId = data.find(val =>
    //         val.value === this.field.value
    //       )
    //       // console.log("this.desinationId--" + this.desinationId.key)
    //       this.apiData.getDesignationData(this.desinationId.key).subscribe(res => {

    //         this.group.get('role').setValue(res.role);
    //         this.group.get('jobLevel').setValue(res.jobLevel);
    //         this.group.get('jobSublevel').setValue(res.jobSublevel);
    //       });

    //     });
    //   }
    // }
  }
  private _filter(value, url) {
    let filterValue = '';
    if (value !== null && value !== '') {
      filterValue = value.toLowerCase();
    }
    // if (this.field.name === "digitalOffering") {
    //   this.group.get('digitalTag').setValue('');
    // }
    if (this.field.url == null) {
      if (this.field.name === 'digitalTag') {
        this.filteredOptions = this.digitalTags;
        // console.log("this.digitalTags == null", this.digitalTags)
        this.filteredOptions = this.filteredOptions.filter((option) =>
          option.value.toLowerCase().includes(filterValue),
        );
        if (this.filteredOptions.length == 0) {
          // console.log(this.filteredOptions.length);
          this.group.get(this.field.name).setErrors({ error: true });
        }
      }
      if (this.field.name === 'previous_employer') {
        this.filteredOptions = this.field.options.filter((option) => option.value.toLowerCase().includes(filterValue));
        // console.log("abc --" + this.filteredOptions)
        //
      } else {
        this.filteredOptions = this.field.options.filter((option) => option.value.toLowerCase().includes(filterValue));
        // console.log("abc --" + this.filteredOptions)
        if (this.filteredOptions.length == 0) {
          // console.log(this.filteredOptions.length);
          this.group.get(this.field.name).setErrors({ error: true });
        }
      }
    } else {
      if (filterValue !== null && filterValue != '') {
        if (this.field.name === 'digitalTag') {
          this.filteredOptions = this.digitalTags;
          // console.log("this.digitalTags !== null", this.digitalTags)
          this.filteredOptions = this.filteredOptions.filter((option) =>
            option.value.toLowerCase().includes(filterValue),
          );
          if (this.filteredOptions.length == 0) {
            // console.log(this.filteredOptions.length);
            this.group.get(this.field.name).setErrors({ error: true });
          }
        } else {
          this.getFilterData(url, filterValue).subscribe((x) => {
            // console.log(filterValue);
            this.filteredOptions = <Options[]>x;
            if (this.filteredOptions.length == 0) {
              // console.log(this.filteredOptions.length);
              this.group.get(this.field.name).setErrors({ required: true });
            }
          });
        }
      }
    }
  }
  getFilterData(url, value) {
    if (value !== null && value != '') {
      return this.http.get(url + '/' + value);
    }
  }

  changeMyControl(): void {}
}
